var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08051 20.9237C0.526322 16.9867 0.246099 12.0205 2.22607 8.02639C4.20796 4.02838 8.45991 1 13.9999 1C19.5819 1 23.847 4.06828 25.8107 8.10183C27.7725 12.1314 27.4429 17.1291 23.8035 21.05L13.8629 31.7595L4.08051 20.9237Z",
    fill: "#4DB595",
    stroke: "#2D594A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.02faed6a.svg";
export { ForwardRef as ReactComponent };